module.exports = __webpack_public_path__ + "static/img/10.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/10.png
// module id = Ri7e
// module chunks = 0